export const API_ERROR_CODES = {
    INVALID_CREDENTIALS_CODE: 2002,
};

export type ApiErrorCode = keyof typeof API_ERROR_CODES;